/**
 * 站点主品牌 logo（BrandLogo / logo_img）仅在首页路由展示
 */
export default {
  computed: {
    showSiteBrandLogo() {
      return this.$route && this.$route.name === "home";
    },
  },
};
